import React from "react";
import { Link } from "react-router-dom";
import desktopfooter from "../../assets/img/desktopfooter.png";
import footermobile from "../../assets/img/footermobile.png";
import logo from '../../assets/img/logo.png';

const Footer = () => {
  return (
    <>
      <footer
        className="main_footer position-relative"
      >
        <div className="footer_object">
          <img src={desktopfooter} alt="" className="d-md-block d-none" />
          <img src={footermobile} alt="" className="d-md-none d-block" />
        </div>
        <div className="container-fluid">
          <div className="row justify-content-between border_bottom px-lg-5">
            <div className="col-lg-4">
              <div className="footer_text">
                <div className="heading-footer">
                  <h6>About Us</h6>
                </div>
                <div className="footerContent">
                  <div
                    className="content_terms"
                    style={{ overflowWrap: "break-word" }}
                  >
                    <p>
                      We offer&nbsp;a seamless experience, connecting you with
                      multiple safari tour operators and providing all the
                      essential details you need to make informed decisions
                      about your wildlife safari, all at no cost.
                    </p>

                    <p>
                      Our shared safari feature connects you with fellow safari
                      enthusiasts, enabling you to form a group and embark on a
                      shared safari adventure together.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-2 Col-md-6">
              <div className="footer_text float-lg-end">
                <div className="heading-footer">
                  <h6> Policy </h6>
                </div>
                <div className="footerContent">
                  <ul className="footer_listing">
                    <li>
                    <Link to="/privacy-policy"> Privacy Policy </Link>
                  </li>
                  <li>
                    <Link to="/terms-of-use"> Terms & Conditions </Link>
                  </li>
                  {/* <li>
                    <Link to="/refund-policy">Refund Policy </Link>
                  </li>
                  <li>
                    <Link to="cancellation"> Cancellation Policy </Link>
                  </li> */}
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="footer_text float-lg-end">
                <div className="heading-footer">
                  <h6>Useful Links </h6>
                </div>
                <div className="footerContent">
                  <ul className="footer_listing">
                     {/*<li>
                      <Link to="/safaritour-registration">
                        Safari Tour Operator
                      </Link>
                    </li>
                    <li>
                      <Link to="/birdingtour-registration">
                        Birding Tour Operator
                      </Link>
                    </li>
                    <li>
                      <Link to="#" style={{ cursor: "default" }}>
                        Resorts / Lodge / Home Stay
                      </Link> 
                    </li>*/}
                    {/* <li>
                      <Link to="/article">Articles and Tips</Link>
                    </li> */}
                    <li>
                      <Link to="/about-us">About Us</Link>
                    </li>
                    <li>
                      <Link to="/contact-us">Contact Us</Link>
                    </li>
                    <li>
                      <Link to="/faq">FAQs</Link>
                    </li>
                    <li>{/* <Link to="/sitemap">Sitemap</Link> */}</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="footer_text float-lg-end">
                <div className="heading-footer">
                  <h6>Contact Info </h6>
                </div>
                <div className="footerContent">
                  <p>
                    <strong>Address:</strong> New Delhi , India
                  </p>
                  <p>
                    <strong>Email:</strong>{" "}
                    <a href="mailto:support@walkintothewild.in">
                      support@walkintothewild.in
                    </a>
                  </p>
                  <div className="d-flex align-items-center gap-2">
                    <div className="insticon">
                      <i className="fa-brands fa-instagram"></i>
                    </div>

                    <Link
                      to="https://www.instagram.com/walkintothewild.in/"
                      target="_blank"
                    >
                      walkintothewild.in
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row pt-4 justify-content-between mobile-responsive align-items-center">
            <div className="col-lg-2 col-xxl-2 ">
              <div className="footerlogo">
                <img src={logo} alt="" width="160" />
              </div>
            </div>
            <div className="col-lg-6 col-xxl-7 ">
              <div className="copyright text-center">
                <p className="text-capitalize">
                  DEVELOPED BY MEDIARC TECHNOLOGIES PRIVATE LIMITED
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-xxl-3 ">
              <div className="d-flex gap-3  justify-content-lg-end justify-content-center">
                <div className="terms">
                  <p className="mb-0  pt-0">
                    COPYRIGHT @ 2024 | ALL RIGHT RESVERD
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
